import useCasMutation, { GenericMutationProps } from './useCasMutation';

type updateMutationProps = GenericMutationProps & {
  url: string;
};

export default function useUpdateMutation({ url, ...rest }: updateMutationProps) {
  return useCasMutation({ method: 'put', url, ...rest });
}
